export const enum SPICE_MONEY {
  SPICE_MONEY_GATWAY = 'KHETI',
}

export const SPICEMONEY_3P_CLIENT_ID = 'spicemoney'
